import React from 'react';

import { DepartmentThin } from 'assets/assetsV1/iconComponents';

import { OBJECTIVE_LEVEL_TAGS } from 'constants/ProjectConstants';
import { NoTagIcon, CompanyTagSvgIcon, TeamTagSvgIcon, IndividualTagSvgIcon } from 'constants/icons';

export const AVAILABLE_TAG_ICONS = {};

OBJECTIVE_LEVEL_TAGS.forEach((tag) => {
  switch (tag.icon) {
    case 'CTagIcon':
      AVAILABLE_TAG_ICONS[tag.value] = <CompanyTagSvgIcon size="fixed18px" />;
      break;
    case 'DTagIcon':
      AVAILABLE_TAG_ICONS[tag.value] = <DepartmentThin color="text.g1" fill="none" padding="1px" boxSize="24px" />;
      break;
    case 'TTagIcon':
      AVAILABLE_TAG_ICONS[tag.value] = <TeamTagSvgIcon size="fixed18px" />;
      break;
    case 'ITagIcon':
      AVAILABLE_TAG_ICONS[tag.value] = <IndividualTagSvgIcon padding="2.5px" size="fixed18px" />;
      break;
    default:
      break;
  }
});

export const TagIcon = React.memo(({ tagId }) => {
  const IconTag = AVAILABLE_TAG_ICONS?.[tagId] || <NoTagIcon size="fixed16px" />;
  return IconTag;
});

export default TagIcon;
